module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-600x338-f5352c8195e413f98503b8c3340bf59f.png";